import {
  TTrainingCourseDetailsFilter,
  TTrainingCoursesDetailsFilter,
} from "~/pages/StaffTrainingDetails/model/config";
import { FILTER_BY } from "~/shared/hooks/useStaffFilterData/useStaffFilterData";
import { dateFormat } from "~/shared/lib/DateFormat/dateFormat";
import {
  EmployeeEducationStatisticsCourseDetailsReportGetterParams,
  EmployeeEducationStatisticsCoursesDetailsReportGetterParams,
} from "~/entity/Employee/model/schema";
import {
  getDealerGroupFilter,
  getFiltersVal,
  resolveGroupFilter,
} from "~/shared/ui/FIlterPresets/DefaultFilterView/model/lib";

// Type guards
export const isCourseParams = (
  params: any
): params is EmployeeEducationStatisticsCourseDetailsReportGetterParams => {
  return "courseId" in params; // или любое другое уникальное свойство
};

export const toServerForCourses = (
  filter: TTrainingCoursesDetailsFilter
): EmployeeEducationStatisticsCoursesDetailsReportGetterParams => {
  const itemsForService = getFiltersVal(filter.filterItems, "string");

  // @ts-ignore
  return {
    dealerGroup: {
      ids: [],
      cities: [],
      FOs: [],
      countries: [],
      subjects: [],
      ...getDealerGroupFilter(
        filter.filterBy?.value as keyof FILTER_BY,
        itemsForService
      ),
    },
    actualOn: dateFormat(filter.period, { type: "date-special" }),
    group: resolveGroupFilter(filter.filterBy?.value as keyof FILTER_BY),
    positionId: getFiltersVal(filter.filterExpectations, "number")[0],
    expectationId: getFiltersVal(filter.filterExpectations, "number")[0],
  };
};

export const toServerForCourse = (
  filter: TTrainingCourseDetailsFilter
): EmployeeEducationStatisticsCourseDetailsReportGetterParams => {
  const itemsForService = getFiltersVal(filter.filterItems, "string");
  return {
    dealerGroup: {
      ids: [],
      cities: [],
      FOs: [],
      countries: [],
      subjects: [],
      ...getDealerGroupFilter(
        filter.filterBy?.value as keyof FILTER_BY,
        itemsForService
      ),
    },
    actualOn: dateFormat(filter.period, { type: "date-special" }),
    group: resolveGroupFilter(filter.filterBy?.value as keyof FILTER_BY),
    expectationId: getFiltersVal(filter.filterExpectations, "number")[0],
    courseId: getFiltersVal(filter.filterCourse || [], "number")[0],
  };
};
